<template>
  <div class="grid pb-0">
    <div class="p-3 bg-white">
      <v-btn-toggle v-model="toggle_exclusive" class="d-gr-btn-update">
        <v-btn v-for="(item, index) in tabItems" :key="item.key" :disabled="item.disabled"
          @click="loadRoute(item.routeName); tab = index" :class="index === tab ? 'd-btn-active' : ''">
          {{ item.title }}
        </v-btn>
      </v-btn-toggle>
    </div>
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <div class="grid-body border-top-unset">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
   
<script>
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
  components: {},
  data() {
    return {
      syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
      isLoading: false,
      systemLang: this.$i18n.locale,
      tab: 0,
      syncInventory: JSON.parse(localStorage.getItem("currentUser")).hotel.syncInventory,
      toggle_exclusive: 0
    };
  },
  computed: {
    tabItems() {
      return [
        {
          title: this.$t('WEEKLY_PRICE'),
          key: 'room-avail',
          disabled: false,
          routeName: "basePriceUpdate",
        },
        {
          title: this.$t('DAILY_PRICE'),
          key: 'price',
          disabled: false,
          routeName: "specialPriceUpdate",
        },
        {
          title: this.$t('HOTEL_ROOM_RATE'),
          key: 'price',
          disabled: false,
          routeName: "priceRoomSpecialUpdate",
        },
        {
          title: this.$t('PRICE_EXTRA'),
          key: 'restriction',
          disabled: false,
          routeName: "priceExtraUpdate",
        },
        {
          title: this.$t('PRICE_EXTRA_DAILY'),
          key: 'stopSell',
          disabled: false,
          routeName: "priceExtraSpecialUpdate",
        },
      ]
    }
  },
  created() {
    switch (this.$route.name) {
      case 'basePriceUpdate':
        this.tab = 0;
        break;
      case 'specialPriceUpdate':
        this.tab = 1;
        break;
      case 'priceRoomSpecialUpdate':
        this.tab = 2;
        break;

      case 'priceExtraUpdate':
        this.tab = 3;
        break;

      case 'priceExtraSpecialUpdate':
        this.tab = 4;
        break;

      default:
        break;
    }
    this.fetchData();
  },
  watch: {
    '$route.query': 'fetchData',
  },
  methods: {
    fetchData() {

    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    _formatCurrency: _formatCurrency,
    formatDate: _formatDate,
  }
};
</script>
   